export default {
  SAVE_LIST_FLOOR: 'SAVE_LIST_FLOOR',
  CLEAR_LIST_FLOOR: 'CLEAR_LIST_FLOOR'
}
